var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "breadcrumb-layout" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "/" } },
            [
              _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                _vm._v("首页")
              ]),
              _vm._v(" "),
              _c("el-breadcrumb-item", [_vm._v("变卖清理单")])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "demo-ruleForm",
          attrs: { model: _vm.assetFiscalClearVoucher, rules: _vm.rulesInfo }
        },
        [
          _c("div", { staticClass: "simple-form" }, [
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [_vm._v("机构信息")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "srcComName" } },
                    [
                      _c("el-input", {
                        staticClass: "width-2x bottom-line",
                        attrs: { disabled: true },
                        model: {
                          value:
                            _vm.assetFiscalClearVoucher.retailerBizUnitName,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.assetFiscalClearVoucher,
                              "retailerBizUnitName",
                              $$v
                            )
                          },
                          expression:
                            "assetFiscalClearVoucher.retailerBizUnitName"
                        }
                      }),
                      _vm._v(" "),
                      _c("i", {
                        staticClass:
                          "icon iconfont icon-chazhaobiaodanliebiao relation-icon",
                        on: { click: _vm.selectSrcComName }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [_vm._v("标题")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value width-2x" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "title" } },
                    [
                      _c("el-input", {
                        attrs: { type: "text", placeholder: "请输入标题" },
                        model: {
                          value: _vm.assetFiscalClearVoucher.title,
                          callback: function($$v) {
                            _vm.$set(_vm.assetFiscalClearVoucher, "title", $$v)
                          },
                          expression: "assetFiscalClearVoucher.title"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", [_vm._v("说明")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value width-2x" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "memo" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          rows: 2,
                          placeholder: "请输入说明"
                        },
                        model: {
                          value: _vm.assetFiscalClearVoucher.memo,
                          callback: function($$v) {
                            _vm.$set(_vm.assetFiscalClearVoucher, "memo", $$v)
                          },
                          expression: "assetFiscalClearVoucher.memo"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _vm.autoApplyAndAudit && false
            ? _c("div", { staticClass: "simple-form" }, [
                _c("div", { staticClass: "form-group center" }, [
                  _c("div", { staticClass: "form-label" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-value" }, [
                    _c(
                      "div",
                      { staticClass: "inline-block mr20" },
                      [
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "el-checkbox",
                              {
                                model: {
                                  value: _vm.autoClearFlag,
                                  callback: function($$v) {
                                    _vm.autoClearFlag = $$v
                                  },
                                  expression: "autoClearFlag"
                                }
                              },
                              [_vm._v("自动清除")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ])
              ])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c("div", { staticClass: "simple-row" }, [
        _c(
          "div",
          { staticClass: "left" },
          [
            _c(
              "el-button",
              {
                attrs: { type: "primary" },
                on: {
                  click: function($event) {
                    _vm.showDeviceListDlg()
                  }
                }
              },
              [_c("span", [_vm._v("通用选择")])]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "right" }, [
          _c("span", [
            _vm._v(
              "已选择(" +
                _vm._s((_vm.assetFiscalClearVoucher.itemList || []).length) +
                ")"
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "table-layout" }, [
        _c(
          "div",
          {
            staticClass: "table-layout",
            staticStyle: { width: "100%", "overflow-x": "auto" }
          },
          [
            _c(
              "el-form",
              {
                ref: "deviceInfo",
                attrs: { model: _vm.assetFiscalClearVoucher }
              },
              [
                _c("table", { staticClass: "custom-tbl error-prompt" }, [
                  _c("thead", { staticClass: "head" }, [
                    _c("tr", { staticClass: "row" }, [
                      _c(
                        "th",
                        {
                          staticStyle: { "text-align": "left" },
                          attrs: { width: "200" }
                        },
                        [_vm._v("部门全称")]
                      ),
                      _vm._v(" "),
                      _c(
                        "th",
                        {
                          staticStyle: { "text-align": "left" },
                          attrs: { width: "300" }
                        },
                        [_vm._v("资产描述全称")]
                      ),
                      _vm._v(" "),
                      _c(
                        "th",
                        {
                          staticStyle: { "text-align": "left" },
                          attrs: { width: "300" }
                        },
                        [_vm._v("名称")]
                      ),
                      _vm._v(" "),
                      _c(
                        "th",
                        {
                          staticStyle: { "text-align": "left" },
                          attrs: { width: "240" }
                        },
                        [_vm._v("型号")]
                      ),
                      _vm._v(" "),
                      _c(
                        "th",
                        {
                          staticStyle: { "text-align": "left" },
                          attrs: { width: "240" }
                        },
                        [_vm._v("规格")]
                      ),
                      _vm._v(" "),
                      _c("th", { attrs: { width: "270" } }, [
                        _vm._v("系统编号")
                      ]),
                      _vm._v(" "),
                      _c("th", { attrs: { width: "260" } }, [
                        _vm._v("商品标识码")
                      ]),
                      _vm._v(" "),
                      _c(
                        "th",
                        {
                          staticStyle: { "text-align": "left" },
                          attrs: { width: "240" }
                        },
                        [_vm._v("资产分类")]
                      ),
                      _vm._v(" "),
                      _c(
                        "th",
                        {
                          staticStyle: { "text-align": "left" },
                          attrs: { width: "100" }
                        },
                        [_vm._v("维保分组")]
                      ),
                      _vm._v(" "),
                      _c(
                        "th",
                        {
                          staticStyle: { "text-align": "left" },
                          attrs: { width: "120" }
                        },
                        [_vm._v("资产品牌")]
                      ),
                      _vm._v(" "),
                      _c(
                        "th",
                        {
                          staticStyle: { "text-align": "center" },
                          attrs: { width: "90" }
                        },
                        [_vm._v("入账方式")]
                      ),
                      _vm._v(" "),
                      _c(
                        "th",
                        {
                          staticStyle: { "text-align": "center" },
                          attrs: { width: "100" }
                        },
                        [_vm._v("是否财务在账")]
                      ),
                      _vm._v(" "),
                      _c(
                        "th",
                        {
                          staticStyle: { "text-align": "right" },
                          attrs: { width: "100" }
                        },
                        [_vm._v("额外收入(元)")]
                      ),
                      _vm._v(" "),
                      _c(
                        "th",
                        {
                          staticStyle: { "text-align": "right" },
                          attrs: { width: "100" }
                        },
                        [_vm._v("额外费用(元)")]
                      ),
                      _vm._v(" "),
                      _c(
                        "th",
                        {
                          staticStyle: { "text-align": "left" },
                          attrs: { width: "160" }
                        },
                        [_vm._v("批次号")]
                      ),
                      _vm._v(" "),
                      _c(
                        "th",
                        {
                          staticStyle: { "text-align": "left" },
                          attrs: { width: "160" }
                        },
                        [_vm._v("资产编号")]
                      ),
                      _vm._v(" "),
                      _c(
                        "th",
                        {
                          staticStyle: { "text-align": "right" },
                          attrs: { width: "100" }
                        },
                        [_vm._v("清理数量")]
                      ),
                      _vm._v(" "),
                      _c("th", { attrs: { width: "80" } }, [_vm._v("单位")]),
                      _vm._v(" "),
                      _c(
                        "th",
                        {
                          staticStyle: { "text-align": "left" },
                          attrs: { width: "120" }
                        },
                        [_vm._v("处理说明")]
                      ),
                      _vm._v(" "),
                      _c(
                        "th",
                        {
                          staticStyle: { "text-align": "left" },
                          attrs: { width: "100" }
                        },
                        [_vm._v("管理方式")]
                      ),
                      _vm._v(" "),
                      _c("th", { attrs: { width: "120" } }, [_vm._v("操作")])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    { staticClass: "body" },
                    _vm._l(_vm.assetFiscalClearVoucher.itemList, function(
                      deviceItem,
                      index
                    ) {
                      return _c("tr", { staticClass: "row" }, [
                        _c("td", { staticStyle: { "text-align": "left" } }, [
                          _vm._v(_vm._s(deviceItem.retailerComFullName))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticStyle: { "text-align": "left" } }, [
                          _vm._v(_vm._s(deviceItem.title))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticStyle: { "text-align": "left" } }, [
                          _vm._v(_vm._s(deviceItem.name))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticStyle: { "text-align": "left" } }, [
                          _vm._v(_vm._s(deviceItem.model))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticStyle: { "text-align": "left" } }, [
                          _vm._v(_vm._s(deviceItem.fixedSpec))
                        ]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(deviceItem.tmpNo))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(deviceItem.vendorUkno))]),
                        _vm._v(" "),
                        _c("td", { staticStyle: { "text-align": "left" } }, [
                          _vm._v(_vm._s(deviceItem.innerDevcCatFullName))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticStyle: { "text-align": "left" } }, [
                          _vm._v(_vm._s(deviceItem.devcGroupFullName))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticStyle: { "text-align": "left" } }, [
                          _vm._v(_vm._s(deviceItem.innerDevcBrandName))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticStyle: { "text-align": "center" } }, [
                          _vm._v(
                            _vm._s(_vm.acctEnterWayMap[deviceItem.acctEnterWay])
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticStyle: { "text-align": "center" } }, [
                          _vm._v(
                            _vm._s(deviceItem.fiscalAcctFlag == 1 ? "是" : "否")
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticStyle: { "text-align": "right" } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "itemList." + index + ".extraIncome",
                                  rules: {
                                    validator: _vm.inputExtraIncome,
                                    trigger: "blur"
                                  }
                                }
                              },
                              [
                                _c("el-input", {
                                  staticClass: "input-content-right",
                                  attrs: { type: "text" },
                                  model: {
                                    value: deviceItem.extraIncome,
                                    callback: function($$v) {
                                      _vm.$set(deviceItem, "extraIncome", $$v)
                                    },
                                    expression: "deviceItem.extraIncome"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticStyle: { "text-align": "right" } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "itemList." + index + ".extraCostFee",
                                  rules: {
                                    validator: _vm.inputExtraCostFee,
                                    trigger: "blur"
                                  }
                                }
                              },
                              [
                                _c("el-input", {
                                  staticClass: "input-content-right",
                                  attrs: { type: "text" },
                                  model: {
                                    value: deviceItem.extraCostFee,
                                    callback: function($$v) {
                                      _vm.$set(deviceItem, "extraCostFee", $$v)
                                    },
                                    expression: "deviceItem.extraCostFee"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("td", { staticStyle: { "text-align": "left" } }, [
                          _vm._v(_vm._s(deviceItem.batchNo))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticStyle: { "text-align": "left" } }, [
                          _vm._v(_vm._s(deviceItem.devcInnerCode))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticStyle: { "text-align": "right" } }, [
                          _vm._v(_vm._s(deviceItem.quantity))
                        ]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(deviceItem.theUnit))]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticStyle: { "text-align": "left" } },
                          [
                            _c("el-input", {
                              staticClass: "textarea-value",
                              attrs: { type: "textarea" },
                              model: {
                                value: deviceItem.handleDesc,
                                callback: function($$v) {
                                  _vm.$set(deviceItem, "handleDesc", $$v)
                                },
                                expression: "deviceItem.handleDesc"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(_vm._s(_vm.assetTypeMap[deviceItem.assetType]))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticStyle: { "text-align": "left" } }, [
                          _c(
                            "a",
                            {
                              staticClass: "swb-btn-link",
                              on: {
                                click: function($event) {
                                  _vm.deleteDevice(index)
                                }
                              }
                            },
                            [_vm._v("移除")]
                          )
                        ])
                      ])
                    })
                  ),
                  _vm._v(" "),
                  _c("tfoot", { staticClass: "foot" }, [
                    _vm.assetFiscalClearVoucher.itemList.length <= 0
                      ? _c("tr", [
                          _c(
                            "td",
                            {
                              staticStyle: {
                                "text-align": "center",
                                "line-height": "40px"
                              },
                              attrs: { colspan: "15" }
                            },
                            [
                              _c("span", { staticClass: "font-gray3" }, [
                                _vm._v("暂无数据")
                              ])
                            ]
                          )
                        ])
                      : _vm._e()
                  ])
                ])
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-toolbar" }, [
        _c(
          "button",
          {
            staticClass: "swb-btn swb-btn-small swb-btn-primary mr10",
            on: { click: _vm.prevStock }
          },
          [_vm._v("返回")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "swb-btn swb-btn-small",
            on: { click: _vm.saveAssetFiscalClearVoucher }
          },
          [_vm._v("保存")]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("清理单信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("资产信息")]),
      _vm._v(" "),
      _c("div", { staticClass: "input-tip error font12" }, [
        _vm._v("提示:一次清理数据最多500条")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-70a8e24c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70a8e24c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/assetFiscal/AssetFiscalClearVoucherSave.vue
// module id = 2618
// module chunks = 0